import { attr, belongsTo } from '@warp-drive/legacy/model';

import Model from 'umg-ember-backend/models/mlp-module';
import { buildValidations } from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({});

export const settings = {
  copyableOptions: { ignoreAttributes: ['contentItem'] },
};

export default class MlpLiveEventFeedModel extends Model.extend(Validations) {
  @attr('number') limit;

  // Relations
  @belongsTo('artist', { async: true, inverse: null }) artist;
  @belongsTo('channel', { async: true, inverse: null }) channel;
}
